<template>
  <div></div>
</template>

<script>
import { modalController } from '@modus/ionic-vue'
import VideoPlayerModal from '@/components/modals/VideoPlayer'
export default {
  name: 'event-video-viewer-manager',
  computed: {
    selectedSiteId: function () {
      return this.$store.getters.selectedSiteId
    },
    siteEvent: function () {
      return this.$store.getters.siteEvent
    },
    eventRecords: function () {
      return this.$store.getters.eventRecords
    },
    recordMedia: function () {
      return this.$store.getters.recordMedia
    },
    statusGetRecordMedia: function () {
      return this.$store.getters.statusGetRecordMedia
    },
    siteActivityLog: function () {
      return this.$store.getters.siteActivityLog
    },
    requestedEventForEventVideoViewer: function () {
      return this.$store.getters.requestedEventForEventVideoViewer
    },
    requestedEventForLiveVideoViewer: function () {
      return this.$store.getters.requestedEventForLiveVideoViewer
    },
    stautsEventVideoUrl() {
      return this.$store.getters?.stautsEventVideoUrl;
    },
  },
  data: function () {
    return {
      liveVideoRequestId: 0,
    }
  },
  watch: {
    requestedEventForEventVideoViewer: function (now, old) {
      if (!this.requestedEventForEventVideoViewer) return
      if (!(this.requestedEventForEventVideoViewer instanceof Object)) return
      // clear event info before store.
      // 1) ID를 ++ 해서 “이전 요청”을 무효화
      this.liveVideoRequestId += 1
      const requestId = this.liveVideoRequestId

      const { eventId, timeStr, deviceName, type } = this.requestedEventForEventVideoViewer

      if (!eventId) return

      this.$store.commit('CLEAR_EVENT_VIEW_INFO')

      // Action - open video
      this.openVideo(eventId, timeStr, deviceName, type, requestId)
    },
    requestedEventForLiveVideoViewer: function () {
      if (!this.requestedEventForLiveVideoViewer) return
      if (!(this.requestedEventForLiveVideoViewer instanceof Object)) return

      // 1) ID를 ++ 해서 “이전 요청”을 무효화
      this.liveVideoRequestId += 1
      const requestId = this.liveVideoRequestId

      const { eventId, timeStr, deviceName, type } = this.requestedEventForLiveVideoViewer

      if (!eventId) return

      this.$store.commit('CLEAR_EVENT_VIEW_INFO')
      // Action - open video
      this.openVideoForLiveView(eventId, timeStr, deviceName, type, requestId)
    },
  },
  created: function () {
  },
  beforeDestroy: function () {
  },
  methods: {
    openVideo: async function (eventId, timeStr, deviceName, type, requestId) {
      // 🗃️ emit start routine to store
      this.$store.commit('IS_FINISH_STORE_EVENT_VIDEO_AND_SNAPSHOTS_ROUTINE', false)

      let chektVideoPlayer = document.getElementById('--chekt-video-player')
      
      if (!chektVideoPlayer) this.openModal(eventId, timeStr, deviceName, type)

      //스냅샷 timeout = 미국에서 한국으로 스냅샷을 보낼때 10~15초, 10*2=20초
      let maxRetry = 10
      let retryInterval = 1000 * 2 // seconds
      let urls = {}

      try {
        // url을 얻기위한 시도
        for (let i=0; i < maxRetry; i++) {
          // **새 요청이 들어와서 ID가 바뀌었으면 즉시 중단**
          if (requestId !== this.liveVideoRequestId) {
            console.log('openVideo: cancelled due to new request')
            return
          }

          urls = await this.getEventVideoAndSnapshots(eventId, requestId)
          
          // video url을 얻을때 까지 시도한다. (최대 20초)
          if (urls?.videoUrl) break

          // retryInterval만큼 기다린후 다시시작
          await this.$tool.wait(retryInterval)
        }
      } 
      catch(err) {
        this.$logger.error(err)
      }

      // 🗃️ emit finish routine to store
      this.$store.commit('IS_FINISH_STORE_EVENT_VIDEO_AND_SNAPSHOTS_ROUTINE', true)
    },
    openVideoForLiveView: async function (eventId, timeStr, deviceName, type, requestId) {
      // 🗃️ emit start routine to store
      this.$store.commit('IS_FINISH_STORE_EVENT_VIDEO_AND_SNAPSHOTS_ROUTINE', false)

      //스냅샷 timeout = 미국에서 한국으로 스냅샷을 보낼때 10~15초, 10*2=20초
      let maxRetry = 10
      let retryInterval = 1000 * 2 // seconds
      let urls = {}

      try {
        // url을 얻기위한 시도
        for (let i=0; i < maxRetry; i++) {   
          // **새 요청이 들어와서 ID가 바뀌었으면 즉시 중단**
          if (requestId !== this.liveVideoRequestId) {
            console.log('openVideoForLiveView: cancelled due to new request')
            return
          }

          urls = await this.getEventVideoAndSnapshots(eventId, requestId)
   
          // video url을 얻을때 까지 시도한다. (최대 20초)
          if (urls?.videoUrl) break

          // retryInterval만큼 기다린후 다시시작
          await this.$tool.wait(retryInterval)
        }
      } 
      catch(err) {
        this.$logger.error(err)
      }

      // 🗃️ emit finish routine to store
      this.$store.commit('IS_FINISH_STORE_EVENT_VIDEO_AND_SNAPSHOTS_ROUTINE', true)
    },
    openModal: function (eventId, timeStr, deviceName, type) { 
      // ACTION - open video
      modalController.create({
      // swipeToClose: true,
      showBackdrop: false,
      component: VideoPlayerModal,
      componentProps: {
        propsData: {
          store: this.$store,
          tool: this.$tool,
          eventId: eventId,
          timeStr: timeStr,
          deviceName: deviceName,
          type: type,
        },
      }}).then(m => m.present())
    },
    getEventVideoAndSnapshots: async function (eventId, requestId) {
      try {
        // 1) 요청 시작 시점에 취소 검사
        if (requestId !== this.liveVideoRequestId) {
          console.log('초기 요청 취소됨', requestId, this.liveVideoRequestId)
          return
        }

        let recordIndex = ''
        let recordId = ''
        let url = ''
        let videoUrl = null
        let snapshotUrls = []

        // 🗃️ emit info to store
        this.$store.commit('STORE_EVENT_SNAPSHOT_URLS_REQUEST')
        this.$store.commit('STORE_EVENT_VIDEO_URL_REQUEST')

        // GET - event media records
        let event = this.siteEvent(eventId)
        if (event === undefined) {
          await this.loadSiteEvent(eventId)
          // 2) 비동기 후에도 취소 검사
          if (requestId !== this.liveVideoRequestId) {
            console.log('loadSiteEvent 후 요청 취소됨')
            return
          }
          event = this.siteEvent(eventId)
        }
        if (event === undefined) return

        const siteId = event.deviceInfo.siteId
        const deviceId = event.deviceInfo.deviceId

        // GET - Media (video.mp4)
        await this.$store.dispatch('getEventRecords', { siteId, deviceId, eventId })
        // 3) dispatch 후 취소 검사
        if (requestId !== this.liveVideoRequestId) {
          console.log('getEventRecords 후 요청 취소됨')
          return
        }

        const eventRecords = this.eventRecords(eventId)
        if (!eventRecords) return

        // 분류
        for (let i = 0; i < eventRecords.length; i++) {
          const rec = eventRecords[i]
          if (String(rec.format).toLowerCase() === 'mp4') {
            recordIndex = i
            recordId = rec.recordId
            url = rec.mediaUrl
          } else {
            snapshotUrls.push(rec.mediaUrl)
          }
        }

        // 4) 스냅샷 커밋 직전에도 취소 검사
        if (requestId === this.liveVideoRequestId) {
          if (snapshotUrls.length) {
            this.$store.commit('STORE_EVENT_SNAPSHOT_URLS_SUCCESS', snapshotUrls)
          } else {
            this.$store.commit('STORE_EVENT_SNAPSHOT_URLS_FAILURE')
          }
        } else {
          console.log('스냅샷 커밋 직전 요청 취소됨')
          return
        }

        // VIDEO - get video src
        const status = this.statusGetRecordMedia(recordId)
        if (status !== 'requested' && status !== 'successful') {
          await this.$store.dispatch('getRecordMedia', { eventId, recordIndex, recordId, url })
          // 5) getRecordMedia 후에도 취소 검사
          if (requestId !== this.liveVideoRequestId) {
            console.log('getRecordMedia 후 요청 취소됨')
            return
          }
        }

        const recordMedia = this.recordMedia(recordId)
        videoUrl = recordMedia

        // 6) 비디오 커밋 전 최종 취소 검사
        if (requestId === this.liveVideoRequestId) {
          if (videoUrl) {
            this.$store.commit('STORE_EVENT_VIDEO_URL_SUCCESS', videoUrl)
          } else {
            this.$store.commit('STORE_EVENT_VIDEO_URL_FAILURE')
          }
        } else {
          console.log('비디오 커밋 직전 요청 취소됨')
          return
        }

        return { snapshotUrls, videoUrl }
      }
      catch (err) {
        console.error(err)
        // 실패 커밋도 취소 검사 후
        if (requestId === this.liveVideoRequestId) {
          this.$store.commit('STORE_EVENT_VIDEO_URL_FAILURE')
          this.$store.commit('STORE_EVENT_SNAPSHOT_URLS_FAILURE')
        }
        return
      }
    },
    loadSiteEvent: async function (eventId) {
      // CHECK - selectedSiteId
      if (!this.selectedSiteId) return
      // ACTION
      return await this.$store.dispatch('getSiteEvent', {
        siteId: this.selectedSiteId,
        eventId,
      })
    },
  }
}
</script>

<style scoped>
</style>
